import { useEffect } from "react";
import { Alert, Anchor, Group, Stack, Text, Title } from "@mantine/core";
import { IconChartDots3, IconInfoCircle } from "@tabler/icons-react";
import { Link, useNavigate } from "@tanstack/react-router";

import { useGrafanaDashboards } from "../lib/grafanaDashboards";

/**
 * Landing page for `/grafana` when the user has not selected a dashboard.
 * If any dashboards are configured, redirects to the first one; otherwise
 * shows an empty-state pointing to Settings.
 */
export function GrafanaIndexPage() {
  const [dashboards] = useGrafanaDashboards();
  const navigate = useNavigate();

  useEffect(() => {
    const first = dashboards[0];
    if (first) {
      void navigate({ to: "/grafana/$dashboardId", params: { dashboardId: first.id }, replace: true });
    }
  }, [dashboards, navigate]);

  if (dashboards.length > 0) return null;

  return (
    <Stack gap="md">
      <Group gap="xs" align="center">
        <IconChartDots3 size={20} />
        <Title order={3}>Grafana</Title>
      </Group>
      <Alert icon={<IconInfoCircle size={16} />} color="blue" variant="light" title="No Grafana dashboards configured">
        <Text size="sm">
          Add one or more dashboards under{" "}
          <Anchor component={Link} to="/settings">Settings</Anchor> to see them listed here and in the sidebar.
        </Text>
      </Alert>
    </Stack>
  );
}
